import React, { useState, useEffect } from 'react';
import Rte from 'react-rte';

export default function RichTextEditor(props) {
  const { value, onChange, ...extraProps } = props;
  const [rteValue, setRteValue] = useState(Rte.createValueFromString(value || '', 'html'));

  useEffect(() => {
    onChange(rteValue.toString('html'));
  }, [rteValue]);

  return (
    <Rte
      value={rteValue}
      onChange={setRteValue}
      {...extraProps}
    />
  )
};
